import { MouseEvent, ReactNode } from 'react';

import { MAIN_ELEMENT_ID } from '../../../../app/layout/Main';
import css from './SkipLink.css';

const MAIN_ELEMENT_SELECTOR = `#${MAIN_ELEMENT_ID}`;

function skipToMainContent(event: MouseEvent<HTMLAnchorElement>) {
  event.preventDefault();

  const mainContent = document.getElementById(MAIN_ELEMENT_ID);

  if (mainContent) {
    mainContent.focus({ preventScroll: true });
  }
}

interface SkipLinkProps {
  children: ReactNode;
}

export default function SkipLink({ children }: SkipLinkProps) {
  return (
    <a className={css.root} href={MAIN_ELEMENT_SELECTOR} onClick={skipToMainContent}>
      {children}
    </a>
  );
}
